import React from 'react'
import { Redirect } from 'react-router-dom'
import { checkRoom } from '../firebase'
import Popup from 'reactjs-popup'
import NewRoom from './NewRoom'
const logo = require('../Assets/icon.png')


export default class Main extends React.Component {

  constructor() {
    super()

    this.state = {
      room_code: "",
      valid: false,
      redirect: false, 
      errorText: ""
    }
  }

  onInputFieldChanged = (event) => {
    this.setState({room_code: event.target.value})
    
  }

  createNewRoom() {
    return Math.floor(100000 + Math.random() * 900000)
  }

  enterRoom = () => {
    checkRoom(this.state.room_code).once('value', snapshot => {
      if(snapshot.val() == null) {
        this.setState({errorText: "You entered and invalid room name"})
      } else {
        this.setState({redirect: true})
      }
    })
  }

  roomValidator() {
    if(this.state.room_code=="") {
      return false
    }
    let letterNumbers = /^[0-9a-zA-Z]+$/

    if(this.state.room_code.match(letterNumbers)) {
      return true
      
    } else {
      return false
    }
  }




render() {

  if(this.state.redirect) {
    return (<Redirect to={`/room/${this.state.room_code}`}/>)
  } else {
    return (
      <div className="Main container">
        <img src={logo} alt="" className="m-4" style={{ width: 156 }} />
        <h5>Enter room code:</h5>
        <div className="input-group mx-0 mb-3 row">
          <input type="text"
            className="form-control text-center col-4 offset-4"
            placeholder="Room name"
            value={this.state.room_code}
            onChange={this.onInputFieldChanged}
          />
        </div>
        <div className="small text-danger mb-3">{this.state.errorText}</div>
        <button className={`btn btn-success mb-3 ${ this.roomValidator() ? "" : "disabled"}`} onClick={this.enterRoom}>Enter room</button>
        <br/>
        <Popup trigger={
          <button className="btn btn-primary mb-3">Create new room</button>
        }
        modal
        closeOnDocumentClick
        >
          <NewRoom/>
        </Popup>
  
        <hr />
        <strong>How to use: </strong><br />
        Generate the NUSMods sharable URL by clicking the Share/Sync button. <br />
        Import your timetable here by pasting the NUSMods sharable URL! <br />
        For a demo, enter room <strong>123456</strong> for a sneak peek!
  
        </div>
    )
  }

  
}
}